import to from 'await-to-js'
import axios from 'axios'

const BASE_URL = 'https://miira-api.herokuapp.com/api'

export default class MainService {
  static async register (data: { username: string, email: string, dream: string}): Promise<any> {
    return await to(axios.post(`${BASE_URL}/user/register`, data)) as any
  }

  static async getPaymentLinks (): Promise<any> {
    return await to(axios.get(`${BASE_URL}/payment_links`)) as any
  }

  static async getPricesPerCountry (): Promise<any> {
    return await to(axios.get(`${BASE_URL}/prices_per_country`)) as any
  }

  static async getCountryCodes (): Promise<any> {
    return await to(axios.get(`${BASE_URL}/country_codes`)) as any
  }

  static async getLocation () {
    return await to(axios.get('https://wtfismyip.com/json')) as any
  }

  static async getCareers (): Promise<any> {
    return await to(axios.get(`${BASE_URL}/careers`)) as any
  }

  static async getUser (token: string): Promise<any> {
    return await to(axios.get(`${BASE_URL}/user`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    })) as any
  }

  static async updateUser (token: string, data: { phone: string, phone_country_code: string, career: string }): Promise<any> {
    return await to(axios.put(`${BASE_URL}/user`, data, {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
    )) as any
  }
}
